import './Footer.css'
import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => (
	<footer className="Footer">
		<Link to="/contact"> Contact </Link>
	</footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/About/Footer.js